import * as React from 'react';
import { connect } from 'react-redux';
import { RedeemCode } from '../../../containers';
import { SubscriptionItem } from '../../controls';
import * as App from 'application';
import { IRootState } from 'store';
import './styles.css';
import { Grid } from 'semantic-ui-react';
import { scrollToTop } from 'application/navigation';

export enum PlanLanguageType {
	Single = 'single',
	Multi = 'multi'
}

export enum PlanSubscriptionType {
	Paid = 'paid',
	Backer = 'backer'
}

export interface IPlanInfo {
	id: string;
	name: string;
	monthlyPrice: number;
	totalPrice: number;
	subscriptionType: PlanSubscriptionType,	//paid, free, backer
	languageType: PlanLanguageType,		// single, multi
	durationMonths: number,
	info: any;
	bestValue?: boolean;
}

const plans: IPlanInfo[] = [{
	name: 'Monthly',
	monthlyPrice: 9.99,
	totalPrice: 9.99,
	info: [<span key="1" className="warn">Your card will be charged once now. </span>, "It won't be charged again until one month after we launch in the App Stores in early 2019 (we will notify you)."],
	id: 'SL-Monthly',
	durationMonths: 1,
	languageType: PlanLanguageType.Single,
	subscriptionType: PlanSubscriptionType.Paid,
},
{
	name: '6-Month',
	monthlyPrice: 8.99,
	totalPrice: 53.94,
	info: '30-Day Money Back Guarantee.',
	id: 'SL-6MO',
	durationMonths: 6,
	languageType: PlanLanguageType.Single,
	subscriptionType: PlanSubscriptionType.Paid,
}, {
	name: '12-Month',
	monthlyPrice: 7.99,
	totalPrice: 95.88,
	info: '30-Day Money Back Guarantee.',
	id: 'SL-12MO',
	durationMonths: 12,
	languageType: PlanLanguageType.Single,
	subscriptionType: PlanSubscriptionType.Paid,
}, {
	name: '24-Month',
	monthlyPrice: 6.99,
	totalPrice: 167.76,
	info: '30-Day Money Back Guarantee.',
	id: 'SL-24MO',
	bestValue: true,
	durationMonths: 24,
	languageType: PlanLanguageType.Single,
	subscriptionType: PlanSubscriptionType.Paid,
},
]

export interface IPlanSubscriptionProps {
	isAllowRedeemCoupone?: boolean;
	planButtonText: string;
	onSubscribe(planId);
}

const mapStateToProps = (state: IRootState) => ({

});

const mapDispatchToProps = (dispatch) => ({
	onSubscribe: (plan: IPlanInfo) => {
		scrollToTop();
		return App.Subscriptions.subscribeToPlan(plan, dispatch)
	},

})

export const PlanSubscriptionView: React.SFC<IPlanSubscriptionProps> = (props) => {
	return (
		<React.Fragment>
			<div className="ui container plans">
				{plans.map((plan) => {
					const { id, name, monthlyPrice, totalPrice, info, bestValue } = plan;
					return (<div key={id} className="plan_column" >
						<SubscriptionItem
							key={id}
							title={name}
							onSubscribe={() => props.onSubscribe(plan)}
							bestValue={bestValue}
							monthlyPrice={monthlyPrice}
							dueToday={totalPrice}
							info={info}
							buttonText={props.planButtonText || "Choose Plan"}
						/></div>);
				})}
			</div>
			{props.isAllowRedeemCoupone &&
				<div className="ui container" style={{ padding: 20 }}>
					<Grid stackable>
						<Grid.Row columns={2}>
							<Grid.Column textAlign="center" verticalAlign="middle" >
								<span className="text-large text-bold">Already a backer or received a gift card?</span>
							</Grid.Column>
							<Grid.Column >
								<RedeemCode onCodeRedeemed={(r) => { /* Add Handler After Code is redeemed */ }} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</div>
			}
		</React.Fragment>
	);
}

PlanSubscriptionView.defaultProps = {
	isAllowRedeemCoupone: true,
}

export const PlanSubscription = connect(mapStateToProps, mapDispatchToProps)(PlanSubscriptionView)



// WEBPACK FOOTER //
// ./src/components/presentational/views/PlanSubscription/index.tsx